import styles from "./TextAndColorInput.module.css";

export default function TextAndColorInput({
	inputProps,
	slotProps,
	colorValue,
	defaultColorValue = "#000000",
	onColorChange,
	colorLabel,
}) {
	return (
		<div {...slotProps("control", styles.control)}>
			<input {...inputProps} type="text" {...slotProps("field", styles.field)} />
			<input
				type="color"
				id={`${inputProps.id}-color`}
				aria-label={colorLabel}
				value={colorValue}
				defaultValue={colorValue === undefined ? defaultColorValue : undefined}
				onChange={onColorChange}
				disabled={inputProps.disabled || inputProps.readOnly}
				{...slotProps("color", styles.color)}
			/>
		</div>
	);
}
